import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Running status icon — spinner / activity arc with a gap and a leading dot.
 *
 * Dual-tone layered style:
 * - Faint circle backdrop: cyan accent fill at 6%
 * - Spinner arc (270° with a gap): currentColor stroke
 * - Leading dot at the arc start: currentColor fill
 *
 * Used for in-progress / running pipeline states.
 */
export const RunningIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size} fill="none">
    {/* Faint circle backdrop — cyan accent fill at 6% */}
    <circle cx="12" cy="12" r="9" fill="#00d4ff" fillOpacity={0.06} />
    {/* Spinner arc — 270° from top, clockwise, leaving a top-left gap */}
    <path
      d="M 12 3 A 9 9 0 1 1 3 12"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Leading dot at the arc start (top) */}
    <circle cx="12" cy="3" r="1.4" fill="currentColor" />
  </RushaSvgIcon>
);

RunningIcon.displayName = "RunningIcon";

export default RunningIcon;
